import React from 'react'
import { Container, Paragraph, Logo, Icon } from '@scentregroup/ui'
import ExternalLink from '../external-link'
import analyticsUtils from '../../helpers/analytics-utils'
import getGiftcardUrl from '../../helpers/get-giftcard-url'
import { useCountryContext } from '../../context'
import style from './index.module.scss'

const NationalHeader: React.FunctionComponent = () => {
  const country = useCountryContext()
  return (
    <Container className={style.logoWrap} type="large">
      <Logo className={style.logo} />
      <div className={style.ctaWrapper}>
        <ExternalLink
          url={getGiftcardUrl(country)}
          eventCategory={analyticsUtils.categories.GIFTCARD_CLICK}
          eventAction={analyticsUtils.actions.GIFTCARD_NAT_HOME_TEXT}
          rel="noopener"
          target="_self"
        >
          <span data-test-id="gift-cards-link">
            <Icon type="gift-cards" className={style.icon} />
            <Paragraph className={style.linkText}>Gift Cards</Paragraph>
          </span>
        </ExternalLink>
      </div>
    </Container>
  )
}

export default NationalHeader
